import { useTranslations } from "@Context/TranslationContext/TranslationContext";
import React from "react";

export type LegendItem = {
  translationKey: string;
  icon?: React.JSX.Element;
};

type LegendLabelProps = {
  legendItems: LegendItem[];
};

export const LegendLabel = ({ legendItems }: LegendLabelProps) => {
  const { t } = useTranslations();

  return (
    <div className="m:mt-3 m:-mb-[10px] m:flex m:flex-row m:gap-4 m:px-4 m:text-base m:font-normal m:text-warmgrey-900 m:antialiased m:md:mb-1 m:md:px-8 m:lg:mb-1 m:lg:text-xl m:lg:tracking-0.4 m:xl:px-10 m:dark:text-blue-200">
      <div className="m:grid m:grid-cols-2 m:gap-x-4 m:gap-y-1" aria-hidden>
        {legendItems.map((item, index) => {
          return (
            <div key={index} className="m:flex m:flex-row m:items-center">
              {item.icon && (
                <span className="m:mr-1 m:flex m:items-center">
                  {item.icon}
                </span>
              )}
              <span className="m:leading-[15px]">
                {t(`legend.${item.translationKey}`)}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
